import * as catalogAction from '../../common/catalog/catalog.actions';
import * as cartActions from '../../common/shopping-cart/cart.actions';
import * as errorAction from '../../common/error-handling/error-handling.actions';
import * as addressActions from '../../tax-and-shipping/address.actions';
import * as addOnAction from '../add-on.actions';
import {routerRequestAction} from '@ngrx/router-store';

export const LOADING_INCREMENT_TYPES = [
  routerRequestAction,
  addOnAction.initializationStart,
  addOnAction.loadAddon,
  addOnAction.loadAddOns,
  addOnAction.externalRedirect,
  cartActions.loadCart,
  cartActions.addItemToCart,
  cartActions.addItemToCartAndContinue,
  cartActions.addItemToCartAndComplete,
  cartActions.addItemToCartAndContinueToShipping,
  cartActions.removeItemFromCartThenShipping,
  cartActions.removeItemFromCart,
  cartActions.completeOrder,
  catalogAction.loadQualifyingCatalogIds,
  errorAction.silentOidcAttemptError,
  addressActions.createAddress,
  addressActions.submitAddress,
  addOnAction.showLoadingIndicator,
] as const;
